import { Component } from "react";
import Select from 'react-select';
import { listBanks } from "../../../../helpers/FuncHelpers";
window.considerarBancos = [];
window.desconsiderarBancos = [];
export default class BeneficiosInss extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDisabledBeneficio: false,
            isDisableDesconsiderarBeneficio: false,
            bancosConsiderar: [],
            bancosDesconsiderar: []
        }

        this.hangeDesconsidera = this.hangeDesconsidera.bind(this)
        this.changeConsidera = this.changeConsidera.bind(this)
        this.handleSelectChangeConsiderar = this.handleSelectChangeConsiderar.bind(this);
        this.handleSelectChangeDesconsiderar = this.handleSelectChangeDesconsiderar.bind(this);
    }

    handleSelectChangeConsiderar(selectedOptions) {
        this.changeConsidera(selectedOptions)
        window.desconsiderarBancos = [];
        window.considerarBancos = selectedOptions.map(option => option.value)
        this.setState({
            bancosConsiderar: selectedOptions.map(option => option.value)
        });
        console.log('considerar', window.considerarBancos)
    }


    handleSelectChangeDesconsiderar(selectedOptions) {
        this.hangeDesconsidera(selectedOptions)
        window.considerarBancos = [];
        window.desconsiderarBancos = selectedOptions.map(option => option.value)
        this.setState({
            bancosDesconsiderar: selectedOptions.map(option => option.value)
        });

        console.log('desconsiderar', window.desconsiderarBancos)
    }

    hangeDesconsidera(e) {
        this.setState({
            isDisabledBeneficio: true
        })
        if (e.length <= 0) {
            this.setState({
                isDisabledBeneficio: false
            })
        }
    }

    changeConsidera(e) {
        this.setState({
            isDisableDesconsiderarBeneficio: true
        })
        if (e.length <= 0) {
            this.setState({
                isDisableDesconsiderarBeneficio: false
            })
        }
    }

    render() {
        const { isDisabledBeneficio, isDisableDesconsiderarBeneficio, bancosConsiderar, bancosDesconsiderar } = this.state
        const bancoList = listBanks();


        return (
            <>
                <div style={{ width: "100%", marginRight: "10px" }}>
                    <label>Considerar</label>
                    <Select
                        classNames={"col-sm-6 col-md-6 col-xl-6"}
                        isMulti
                        isDisabled={isDisabledBeneficio}
                        options={bancoList}
                        value={bancoList.filter(option => bancosConsiderar.includes(option.value))}
                        onChange={(e) => { this.handleSelectChangeConsiderar(e) }}
                        isSearchable={true} // Habilita a pesquisa
                        placeholder="Considerar Bancos" // Texto do placeholder
                        noOptionsMessage={() => 'Considerar Bancos'} // Mensagem exibida quando não há opções encontradas
                    />

                    <label>Desconsiderar</label>
                    <Select
                        classNames={"col-sm-6 col-md-6 col-xl-6"}
                        isMulti
                        isDisabled={isDisableDesconsiderarBeneficio}
                        options={bancoList}
                        value={bancoList.filter(option => bancosDesconsiderar.includes(option.value))}
                        onChange={(e) => { this.handleSelectChangeDesconsiderar(e) }}
                        isSearchable={true} // Habilita a pesquisa
                        placeholder="Desconsiderar Bancos" // Texto do placeholder
                        noOptionsMessage={() => 'Desconsiderar Bancos'} // Mensagem exibida quando não há opções encontradas
                    />
                </div>
            </>
        )
    }
}

